import { styled } from "@mui/material/styles";
import {FlexBox} from "../../Box";

export const ContentContainer = styled(FlexBox)(() => ({
  flexDirection: 'column',
  paddingLeft: "20px",
  paddingRight: "20px",
}));
